import { type EventFeedback } from 'models';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Section, RateInput, ModalFormActions } from 'ui';

type P = {
  onSubmit: (data: EventFeedback) => void;
  onCancel: () => void;
  loading: boolean;
};

export const EventFeedbackForm: FC<P> = ({ onSubmit, onCancel, loading }) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();

  const onFinish = (data: EventFeedback) => onSubmit(data);

  return (
    <Form<EventFeedback> onFinish={onFinish} form={form}>
      <Section paddingTop={false} paddingBottom={false}>
        <RateInput
          item={{
            name: 'isHelpful',
            label: 'How helpful was this event? ',
            rules: [
              {
                required: true,
                message: t('This field is required'),
              },
            ],
          }}
        />
      </Section>
      <Section paddingTop paddingBottom={false}>
        <RateInput
          item={{
            name: 'isAudioOk',
            label: 'How would you rate the audio quality?',
            rules: [
              {
                required: true,
                message: t('This field is required'),
              },
            ],
          }}
        />
      </Section>
      <Section paddingTop paddingBottom={false}>
        <RateInput
          item={{
            name: 'isVideoOk',
            label: 'How would you rate the video quality?',
            rules: [
              {
                required: true,
                message: t('This field is required'),
              },
            ],
          }}
        />
      </Section>
      <ModalFormActions
        left={{ onClick: onCancel, children: 'Skip rating' }}
        submit={{ children: 'Send feedback', loading }}
      />
    </Form>
  );
};
